module.exports = __webpack_public_path__ + "static/media/steve-and-curtis.a31eb760.jpg";